import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'gatsby-link';

function Laverage(props) {
    return (
        <div className="laverage_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>The Website Design & Development Process We Follow</h2>
                        <p>Everything done through a process automatically becomes better. To develop state-of-the-art web development solutions for Dubai and GCC projects, we follow a highly efficient and time-tested indigenous process that has helped us to be one of the best web development companies in the region.</p>
                        <p>Here are some of the TekRevol-exclusive features of the process that we use to build incredible web design and development solutions that deliver exceptionally for modern businesses.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>On-Time Deliverables</h6>
                                <p>Timeliness is critical when you are on a mission to change the world and revolutionize. Our deliverables are on time, and we ensure that our clients get what they want.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>Easy Web Design & Development</h6>
                                <p>Our web design and development process incorporates all the necessary steps – broken into small tasks and milestones – that we use to deliver exceptional website solutions.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Qualified & Skilled Teams</h6>
                                <p>TekRevol’s team consists of qualified and skilled experts led by experienced individuals with 5+ years of experience in their relevant domain.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Trust In Process</h6>
                                <p>We have the indigenous process that we follow to deliver projects with utmost precision, avoiding any issues and reducing the cost for you. We trust in the process because you trust us.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">05</div>
                                <h6>Post-Launch Support</h6>
                                <p>Aftersales is the backbone of any business, and believe us when we say this; we take it very seriously. We provide comprehensive post-launch support to all our clients.</p>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;